import { ActionItemFragment } from '@/modules/tasks/features/actionItems/graphql/fragments/generated/ActionItem';
import { ProviderType, RelatedEntityTypeEnum } from '@/types/schema';

export interface AutoSyncFromJiraModalProps {
  onClose: () => void;
  onSubmit: () => void;
  provider: ProviderType;
  entityId?: string;
  entity?: RelatedEntityTypeEnum;
  fileId?: string | null;
  actionItems?: ActionItemFragment[];
}

export enum AutoSyncActions {
  'Create' = 'CREATE',
  'Edit' = 'EDIT',
  'Delete' = 'DELETE',
  'DeleteForSure' = 'DELETE_FOR_SURE',
  'OpenInProvider' = 'OPEN_IN_PROVIDER',
}
